export default {
    Default: "SlideFromRight",
    SlideFromBottom: "SlideFromBottom",
    SlideFromLeft: "SlideFromLeft",
    SlideFromRight: "SlideFromRight",
    SlideFromTop: "SlideFromTop",
    CollapseExpand: "CollapseExpand",
}